"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TypographyContext", {
  enumerable: true,
  get: function get() {
    return _TypographyContext["default"];
  }
});
Object.defineProperty(exports, "TypographyContextProvider", {
  enumerable: true,
  get: function get() {
    return _TypographyContext.TypographyContextProvider;
  }
});
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _isNull2 = _interopRequireDefault(require("lodash/isNull"));

var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));

var _react = _interopRequireWildcard(require("react"));

var _TypeImpl = _interopRequireDefault(require("./TypeImpl"));

var _TypographyContext = _interopRequireWildcard(require("./TypographyContext"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// These are the values we need to supply to child components via TypographyContext
// Should be kept in sync with the `TypeVisualProps` type definition in `TypeImpl.ts `
var VISUAL_PROPS = ['bold', 'chronicle', 'color', 'error', 'gotham', 'inline', 'italic', 'light', 'size', 'uppercase'];

var Type = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      component = _ref.component,
      otherProps = _objectWithoutProperties(_ref, ["children", "component"]);

  var typographyContext = (0, _react.useContext)(_TypographyContext["default"]); // ensure that component props are not null so defaults spread evenly

  var props = (0, _pickBy2["default"])(otherProps, function (val) {
    return !(0, _isNull2["default"])(val);
  }); // supply any undefined or null visual props from TypographyContext
  // gotham and chronicle are mutually exclusive. Values in props must override values in context.
  // Without unsetting the other font type, a nested <Type/> will receive both props, which
  // is undefined behavior and has the effect of rendering chronicle. This also must be done in TypographyContext
  // See https://github.com/NerdWallet/structured-content/pull/298

  var propsFromContext = (0, _pickBy2["default"])(typographyContext, function (val, key) {
    if (key === 'gotham' && val && props.chronicle) return false;
    if (key === 'chronicle' && val && props.gotham) return false;
    return (0, _isUndefined2["default"])(props[key]);
  });

  var passedPropsMergedWithPropsFromContext = _objectSpread(_objectSpread(_objectSpread({}, propsFromContext), props), {}, {
    component: component
  });

  return /*#__PURE__*/_react["default"].createElement(_TypographyContext.TypographyContextProvider // provide all needed props as context for child <Type /> nodes
  , _extends({}, (0, _pick2["default"])(props, VISUAL_PROPS), {
    // nested type is always `inline`
    inline: true
  }), /*#__PURE__*/_react["default"].createElement(_TypeImpl["default"], _extends({}, passedPropsMergedWithPropsFromContext, {
    ref: ref
  }), children));
});

Type.displayName = 'Type';
Type.propTypes = (0, _omit2["default"])(_TypeImpl["default"].propTypes, 'inline');
var _default = Type;
exports["default"] = _default;